var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"document-list"},[[_c('documents-tree',{attrs:{"documents":_vm.documents,"allowDelete":_vm.showDelete,"allowEdit":_vm.showDelete}})],(_vm.showDelete)?_c('document-upload'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }